import { Component, h, Host } from '@stencil/core';
import { theme } from '@eventstore-ui/theme';

/**
 * Displays Es Database illustration.
 * @part illustration - The root svg of the illustration.
 */
@Component({
    tag: 'es-illustration-es-database',
    styleUrl: 'es-database.css',
    shadow: true,
})
export class EsIllustrationEsDatabase {
    render() {
        const isDark = theme.isDark();

        return (
            <Host dark={isDark} light={!isDark}>
                {isDark ? this.renderDark() : this.renderLight()}
            </Host>
        );
    }

    renderLight() {
        return (
            <svg
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 1038 1198.9"
                aria-hidden="true"
                width="100%"
                height="100%"
                focusable="false"
                role="img"
                part="illustration"
            >
                <defs>
                    <linearGradient
                        id="es_database_b"
                        x1="7.2"
                        x2="1030.6"
                        y1="896.5"
                        y2="896.5"
                        gradientUnits="userSpaceOnUse"
                    >
                        <stop offset="0" stop-color="#fff" />
                        <stop offset=".2" stop-color="#f9fcfe" />
                        <stop offset=".5" stop-color="#ebf4fc" />
                        <stop offset=".8" stop-color="#d2e8f8" />
                        <stop offset="1" stop-color="#bcddf5" />
                    </linearGradient>
                    <linearGradient
                        id="es_database_c"
                        x1="99.3"
                        x2="938.4"
                        y1="780.8"
                        y2="780.8"
                        gradientUnits="userSpaceOnUse"
                    >
                        <stop
                            offset="0"
                            stop-color="#5cb253"
                            stop-opacity=".3"
                        />
                        <stop
                            offset=".2"
                            stop-color="#5cb253"
                            stop-opacity=".4"
                        />
                        <stop
                            offset=".5"
                            stop-color="#5cb253"
                            stop-opacity=".4"
                        />
                        <stop
                            offset=".8"
                            stop-color="#5cb253"
                            stop-opacity=".6"
                        />
                        <stop
                            offset="1"
                            stop-color="#5cb253"
                            stop-opacity=".7"
                        />
                    </linearGradient>
                    <linearGradient
                        id="es_database_d"
                        y1="665"
                        y2="665"
                        href="#es_database_b"
                    />
                    <linearGradient
                        id="es_database_e"
                        y1="549.2"
                        y2="549.2"
                        href="#es_database_c"
                    />
                    <linearGradient
                        id="es_database_f"
                        y1="419"
                        y2="419"
                        href="#es_database_b"
                    />
                </defs>
                <path
                    fill="url(#es_database_b)"
                    fill-rule="evenodd"
                    d="M1030.5 904.2c.2-4.4.2-8.7 0-13.1V779.3h-42.3c-25-33.2-61-64.2-108-91.4C680 572.4 356 572.2 156.5 687.4c-47.2 27.2-83.2 58.5-108 91.9h-41V885c-4.9 79.3 45.1 159.5 150.1 220.1 200.2 115.5 524.2 115.7 723.7.5 96.5-55.7 146.2-128.3 149.1-201.4Z"
                />
                <path
                    fill="#fff"
                    fill-rule="evenodd"
                    d="M156.4 571.7c199.5-115.2 523.5-114.9 723.7.5 200.2 115.5 200.7 302.5 1.2 417.7-199.5 115.2-523.5 114.9-723.7-.5-200.2-115.5-200.7-302.5-1.2-417.7Z"
                />
                <path
                    fill="#1b4e85"
                    d="M1004.4 870.9c-24.2 43.7-66.3 83.7-124.2 117.1-99.1 57.2-229.4 85.8-359.8 85.8-130.9 0-261.9-28.8-361.7-86.4-60.5-34.9-103.9-76.9-127.8-122.7-1.1 1-2.3 1.9-3.4 2.9 24.4 46.2 68.2 88.5 129.1 123.6 97.1 56 226.1 87 363.2 87.1h.7c136.8 0 265.3-30.7 362-86.5 58.1-33.5 100.5-73.7 125.2-117.7l-3.2-3.2Z"
                />
                <path
                    fill="none"
                    fill-rule="evenodd"
                    stroke="#1b4e85"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    stroke-width="14"
                    d="M1030.5 788.4c3.1-78-47-156.6-150.3-216.2C680 456.7 356 456.5 156.5 571.7 52.2 631.8 2.6 711.6 7.5 790.6V885c-4.9 79.3 45.1 159.5 150.1 220.1 200.2 115.5 524.2 115.7 723.7.5 96.5-55.7 146.2-128.3 149.1-201.4h0c.2-4.4.2-8.8 0-13.1V788.4Z"
                />
                <path
                    fill="none"
                    fill-rule="evenodd"
                    stroke="#1b4e85"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    stroke-width="3.6"
                    d="M221.7 609.3c163.6-94.4 429.2-94.2 593.4.4 164.1 94.7 164.6 248 1 342.4-163.6 94.4-429.2 94.2-593.4-.4-164.1-94.7-164.6-248-1-342.5Z"
                />
                <path
                    fill="url(#es_database_c)"
                    fill-rule="evenodd"
                    d="M221.7 609.3c163.6-94.4 429.2-94.2 593.4.4 164.1 94.7 164.6 248 1 342.4-163.6 94.4-429.2 94.2-593.4-.4-164.1-94.7-164.6-248-1-342.5Z"
                />
                <path
                    fill="url(#es_database_d)"
                    fill-rule="evenodd"
                    d="M1030.5 672.7c.2-4.4.2-8.7 0-13.1V547.8h-42.3c-25-33.2-61-64.2-108-91.4C680 340.9 356 340.7 156.5 455.9c-47.2 27.2-83.2 58.5-108 91.9h-41v105.7C2.6 732.8 52.6 813 157.6 873.6c200.2 115.5 524.2 115.7 723.7.5 96.5-55.7 146.2-128.3 149.1-201.4Z"
                />
                <path
                    fill="#fff"
                    fill-rule="evenodd"
                    d="M156.4 340.1c199.5-115.2 523.5-114.9 723.7.5 200.2 115.5 200.7 302.5 1.2 417.7-199.5 115.2-523.5 114.9-723.7-.5-200.2-115.5-200.7-302.5-1.2-417.7Z"
                />
                <path
                    fill="#1b4e85"
                    d="M1004.4 639.3C980.2 683 938.1 723 880.2 756.4c-99.1 57.2-229.4 85.8-359.8 85.8-130.9 0-261.9-28.8-361.7-86.4-60.5-34.9-103.9-76.9-127.8-122.7-1.1 1-2.3 1.9-3.4 2.9 24.4 46.2 68.2 88.5 129.1 123.6 97.1 56 226.1 87 363.2 87.1h.7c136.8 0 265.3-30.7 362-86.5 58.1-33.5 100.5-73.7 125.2-117.7l-3.2-3.2Z"
                />
                <path
                    fill="none"
                    fill-rule="evenodd"
                    stroke="#1b4e85"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    stroke-width="14"
                    d="M1030.5 556.9c3.1-78-47-156.6-150.3-216.2C680 225.2 356 225 156.5 340.2 52.2 400.3 2.6 480.1 7.5 559v94.4c-4.9 79.3 45.1 159.5 150.1 220.1 200.2 115.5 524.2 115.7 723.7.5 96.5-55.7 146.2-128.3 149.1-201.4h0c.2-4.4.2-8.8 0-13.1V556.8Z"
                />
                <path
                    fill="none"
                    fill-rule="evenodd"
                    stroke="#1b4e85"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    stroke-width="3.6"
                    d="M221.7 377.8c163.6-94.4 429.2-94.2 593.4.4 164.1 94.7 164.6 248 1 342.4-163.6 94.4-429.2 94.2-593.4-.4-164.1-94.7-164.6-248-1-342.5Z"
                />
                <path
                    fill="url(#es_database_e)"
                    fill-rule="evenodd"
                    d="M221.7 377.8c163.6-94.4 429.2-94.2 593.4.4 164.1 94.7 164.6 248 1 342.4-163.6 94.4-429.2 94.2-593.4-.4-164.1-94.7-164.6-248-1-342.5Z"
                />
                <path
                    fill="url(#es_database_f)"
                    fill-rule="evenodd"
                    d="M1030.5 426.6c.2-4.4.2-8.7 0-13.1V301.7h-42.3c-25-33.2-61-64.2-108-91.4C680 94.8 356 94.6 156.5 209.8c-47.2 27.2-83.2 58.5-108 91.9h-41v105.7c-4.9 79.3 45.1 159.5 150.1 220.1 200.2 115.5 524.2 115.7 723.7.5 96.5-55.7 146.2-128.3 149.1-201.4Z"
                />
                <path
                    fill="#fff"
                    fill-rule="evenodd"
                    d="M156.4 94.1c199.5-115.2 523.5-114.9 723.7.5 200.2 115.5 200.7 302.5 1.2 417.7-199.5 115.2-523.5 114.9-723.7-.5-200.2-115.5-200.7-302.5-1.2-417.7Z"
                />
                <path
                    fill="#1b4e85"
                    d="M1004.4 393.3C980.2 437 938.1 477 880.2 510.4c-99.1 57.2-229.4 85.8-359.8 85.8-130.9 0-261.9-28.8-361.7-86.4-60.5-34.9-103.9-76.9-127.8-122.7-1.1 1-2.3 1.9-3.4 2.9 24.4 46.2 68.2 88.5 129.1 123.6 97.1 56 226.1 87 363.2 87.1h.7c136.8 0 265.3-30.7 362-86.5 58.1-33.5 100.5-73.7 125.2-117.7l-3.2-3.2Z"
                />
                <path
                    fill="none"
                    fill-rule="evenodd"
                    stroke="#1b4e85"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    stroke-width="14"
                    d="M1030.5 310.9c3.1-78-47-156.6-150.3-216.2C680-20.8 356-21 156.5 94.2 52.2 154.3 2.6 234.1 7.5 313v94.4c-4.9 79.3 45.1 159.5 150.1 220.1 200.2 115.5 524.2 115.7 723.7.5 96.5-55.7 146.2-128.3 149.1-201.4h0c.2-4.4.2-8.8 0-13.1V310.8Z"
                />
                <path
                    fill="none"
                    fill-rule="evenodd"
                    stroke="#1b4e85"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    stroke-width="3.6"
                    d="M221.7 131.8c163.6-94.4 429.2-94.2 593.4.4 164.1 94.7 164.6 248 1 342.4-163.6 94.4-429.2 94.2-593.4-.4-164.1-94.7-164.6-248-1-342.5Z"
                />
                <path
                    fill="#5cb253"
                    d="m699.2 240.4 31.3-46.5c-13.5-9.4-28.9-17.8-46.3-25.3-27.6-11.8-58.1-20.4-91.6-25.7-15.8-2.5-31.9-4.3-48.1-5.5-11.5-.8-23.1-1.3-34.8-1.5-19.4-.3-38.9 0-58.4.9l64.8 41.3-30 43.1c7.7-.2 15.5 0 23.6.4 35.5 2 67.4 9 95.5 21 2.7 1.1 5.3 2.3 7.8 3.5l86.2-5.7Z"
                />
                <path
                    fill="#5cb253"
                    d="M404 172.4c-11.1 2.6-21.7 5.5-31.9 8.9l41.3 8.9 4.5 23.2c1.5-.5 3.1-1.1 4.6-1.6 21.4-7.1 44.2-12.1 68.5-14.8l12.3-17.6-26.9-17.1c-24.8 1.3-49 4.7-72.4 10.1Z"
                />
                <path
                    fill="#5cb253"
                    d="m403.1 194.6-42.7-9.2c-14.2 5.3-27.5 11.4-39.8 18.3-20.6 11.6-37 24.8-49.2 39.5l49-5.8 29.8 20.4c1-1.3 2.1-2.6 3.3-4 12.9-14.8 30.9-26.9 54.1-36.4l-4.5-22.8ZM641.4 346.1c4.6-4.3 8.4-8.7 11.4-13.2l46.2 31.3 77.6-9.4c-4.4 6.8-9.7 13.5-15.8 20.1-16 17.2-37 32.1-63.1 44.8-26.5 12.9-56.5 22.2-90 28.1l-2 .3-57.5-27.2 15.1-37 1.1-.3c32.9-7.8 58.6-20.4 76.9-37.7Z"
                />
                <path
                    fill="#5cb253"
                    d="M752 211.2c-4.2-3.9-8.7-7.7-13.4-11.4l-31.3 46.4-83.7 5.5c17.7 10.5 29.3 23.2 34.7 38 4.6 12.5 4.1 24.6-1.5 36.1l46.5 31.4 77.5-9.3c4.9-8.7 8.4-17.6 10.8-26.7 4.8-19 3.9-37.9-2.9-56.7-6.8-19-19-36.8-36.7-53.4ZM266 250.2l50-5.9 29.5 20.1c-9 14.4-11.3 29.5-6.8 45.1 1.3 4.4 3 8.7 5.2 12.9l-52.8-6.7-38 25.1c-4.6-11.1-6.8-22.5-6.8-34.1 0-19.3 6.5-38 19.2-56 .1-.2.2-.4.4-.5Z"
                />
                <path
                    fill="#5cb253"
                    d="M381.7 360.2c-14.8-9.4-26-19.7-33.5-30.9l-52.8-6.7-38.7 25.6c2.6 5.1 5.6 10.1 9.1 15 13 18.1 31.6 34.1 55.9 48.1 14.5 8.3 30.4 15.5 47.7 21.6l-2.8-38.2 52.5-16.8c-13.7-4.6-26.1-10.5-37.3-17.6Z"
                />
                <path
                    fill="#5cb253"
                    d="M430.4 381.3c11.3 3.1 23.4 5.5 36.2 7.2 28.8 3.7 56.8 3.1 84.2-1.9l-14.9 36.8 57 26.9c-28.5 4.2-57.6 5.9-87.3 5.4-34.7-.6-68-4.7-99.9-12.3-8.6-2-16.8-4.3-24.8-6.8l-2.8-38.5 52.5-16.8Z"
                />
            </svg>
        );
    }

    renderDark() {
        return (
            <svg
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 1038 1198.9"
                aria-hidden="true"
                width="100%"
                height="100%"
                focusable="false"
                role="img"
                part="illustration"
            >
                <defs>
                    <linearGradient
                        id="es_database_b"
                        x1="7.2"
                        x2="1030.6"
                        y1="896.5"
                        y2="896.5"
                        gradientUnits="userSpaceOnUse"
                    >
                        <stop offset="0" stop-color="#ced4db" />
                        <stop offset=".1" stop-color="#c8cfd7" />
                        <stop offset=".3" stop-color="#bac2cc" />
                        <stop offset=".4" stop-color="#a1acba" />
                        <stop offset=".6" stop-color="#7f8ea1" />
                        <stop offset=".8" stop-color="#536780" />
                        <stop offset=".9" stop-color="#1e395a" />
                        <stop offset="1" stop-color="#09264a" />
                    </linearGradient>
                    <linearGradient
                        id="es_database_c"
                        x1="99.3"
                        x2="938.4"
                        y1="780.8"
                        y2="780.8"
                        gradientUnits="userSpaceOnUse"
                    >
                        <stop
                            offset="0"
                            stop-color="#5cb253"
                            stop-opacity=".3"
                        />
                        <stop
                            offset=".2"
                            stop-color="#5cb253"
                            stop-opacity=".4"
                        />
                        <stop
                            offset=".5"
                            stop-color="#5cb253"
                            stop-opacity=".4"
                        />
                        <stop
                            offset=".8"
                            stop-color="#5cb253"
                            stop-opacity=".6"
                        />
                        <stop
                            offset="1"
                            stop-color="#5cb253"
                            stop-opacity=".7"
                        />
                    </linearGradient>
                    <linearGradient
                        id="es_database_d"
                        x1="7.2"
                        x2="1030.6"
                        y1="665"
                        y2="665"
                        gradientUnits="userSpaceOnUse"
                    >
                        <stop offset="0" stop-color="#ced4db" />
                        <stop offset=".1" stop-color="#c8cfd7" />
                        <stop offset=".3" stop-color="#bac2cc" />
                        <stop offset=".4" stop-color="#a1acba" />
                        <stop offset=".6" stop-color="#7f8ea1" />
                        <stop offset=".8" stop-color="#536780" />
                        <stop offset=".9" stop-color="#1e395a" />
                        <stop offset="1" stop-color="#09264a" />
                    </linearGradient>
                    <linearGradient
                        id="es_database_e"
                        y1="549.2"
                        y2="549.2"
                        href="#es_database_c"
                    />
                    <linearGradient
                        id="es_database_f"
                        x1="7.2"
                        x2="1030.6"
                        y1="419"
                        y2="419"
                        gradientUnits="userSpaceOnUse"
                    >
                        <stop offset="0" stop-color="#ced4db" />
                        <stop offset=".1" stop-color="#c8cfd7" />
                        <stop offset=".3" stop-color="#bac2cc" />
                        <stop offset=".4" stop-color="#a1acba" />
                        <stop offset=".6" stop-color="#7f8ea1" />
                        <stop offset=".8" stop-color="#536780" />
                        <stop offset=".9" stop-color="#1e395a" />
                        <stop offset="1" stop-color="#09264a" />
                    </linearGradient>
                </defs>
                <path
                    fill="url(#es_database_b)"
                    fill-rule="evenodd"
                    d="M1030.5 904.2c.2-4.4.2-8.7 0-13.1V779.3h-42.3c-25-33.2-61-64.2-108-91.4C680 572.4 356 572.2 156.5 687.4c-47.2 27.2-83.2 58.5-108 91.9h-41V885c-4.9 79.3 45.1 159.5 150.1 220.1 200.2 115.5 524.2 115.7 723.7.5 96.5-55.7 146.2-128.3 149.1-201.4Z"
                />
                <path
                    fill="#ced4db"
                    fill-rule="evenodd"
                    d="M156.4 571.7c199.5-115.2 523.5-114.9 723.7.5 200.2 115.5 200.7 302.5 1.2 417.7-199.5 115.2-523.5 114.9-723.7-.5-200.2-115.5-200.7-302.5-1.2-417.7Z"
                />
                <path
                    fill="#09264a"
                    d="M1004.4 870.9c-24.2 43.7-66.3 83.7-124.2 117.1-99.1 57.2-229.4 85.8-359.8 85.8-130.9 0-261.9-28.8-361.7-86.4-60.5-34.9-103.9-76.9-127.8-122.7-1.1 1-2.3 1.9-3.4 2.9 24.4 46.2 68.2 88.5 129.1 123.6 97.1 56 226.1 87 363.2 87.1h.7c136.8 0 265.3-30.7 362-86.5 58.1-33.5 100.5-73.7 125.2-117.7l-3.2-3.2Z"
                />
                <path
                    fill="none"
                    fill-rule="evenodd"
                    stroke="#fff"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    stroke-width="14"
                    d="M1030.5 788.4c3.1-78-47-156.6-150.3-216.2C680 456.7 356 456.5 156.5 571.7 52.2 631.8 2.6 711.6 7.5 790.6V885c-4.9 79.3 45.1 159.5 150.1 220.1 200.2 115.5 524.2 115.7 723.7.5 96.5-55.7 146.2-128.3 149.1-201.4h0c.2-4.4.2-8.8 0-13.1V788.4Z"
                />
                <path
                    fill="none"
                    fill-rule="evenodd"
                    stroke="#09264a"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    stroke-width="3.6"
                    d="M221.7 609.3c163.6-94.4 429.2-94.2 593.4.4 164.1 94.7 164.6 248 1 342.4-163.6 94.4-429.2 94.2-593.4-.4-164.1-94.7-164.6-248-1-342.5Z"
                />
                <path
                    fill="url(#es_database_c)"
                    fill-rule="evenodd"
                    d="M221.7 609.3c163.6-94.4 429.2-94.2 593.4.4 164.1 94.7 164.6 248 1 342.4-163.6 94.4-429.2 94.2-593.4-.4-164.1-94.7-164.6-248-1-342.5Z"
                />
                <path
                    fill="url(#es_database_d)"
                    fill-rule="evenodd"
                    d="M1030.5 672.7c.2-4.4.2-8.7 0-13.1V547.8h-42.3c-25-33.2-61-64.2-108-91.4C680 340.9 356 340.7 156.5 455.9c-47.2 27.2-83.2 58.5-108 91.9h-41v105.7C2.6 732.8 52.6 813 157.6 873.6c200.2 115.5 524.2 115.7 723.7.5 96.5-55.7 146.2-128.3 149.1-201.4Z"
                />
                <path
                    fill="#ced4db"
                    fill-rule="evenodd"
                    d="M156.4 340.1c199.5-115.2 523.5-114.9 723.7.5 200.2 115.5 200.7 302.5 1.2 417.7-199.5 115.2-523.5 114.9-723.7-.5-200.2-115.5-200.7-302.5-1.2-417.7Z"
                />
                <path
                    fill="#09264a"
                    d="M1004.4 639.3C980.2 683 938.1 723 880.2 756.4c-99.1 57.2-229.4 85.8-359.8 85.8-130.9 0-261.9-28.8-361.7-86.4-60.5-34.9-103.9-76.9-127.8-122.7-1.1 1-2.3 1.9-3.4 2.9 24.4 46.2 68.2 88.5 129.1 123.6 97.1 56 226.1 87 363.2 87.1h.7c136.8 0 265.3-30.7 362-86.5 58.1-33.5 100.5-73.7 125.2-117.7l-3.2-3.2Z"
                />
                <path
                    fill="none"
                    fill-rule="evenodd"
                    stroke="#fff"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    stroke-width="14"
                    d="M1030.5 556.9c3.1-78-47-156.6-150.3-216.2C680 225.2 356 225 156.5 340.2 52.2 400.3 2.6 480.1 7.5 559v94.4c-4.9 79.3 45.1 159.5 150.1 220.1 200.2 115.5 524.2 115.7 723.7.5 96.5-55.7 146.2-128.3 149.1-201.4h0c.2-4.4.2-8.8 0-13.1V556.8Z"
                />
                <path
                    fill="none"
                    fill-rule="evenodd"
                    stroke="#09264a"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    stroke-width="3.6"
                    d="M221.7 377.8c163.6-94.4 429.2-94.2 593.4.4 164.1 94.7 164.6 248 1 342.4-163.6 94.4-429.2 94.2-593.4-.4-164.1-94.7-164.6-248-1-342.5Z"
                />
                <path
                    fill="url(#es_database_e)"
                    fill-rule="evenodd"
                    d="M221.7 377.8c163.6-94.4 429.2-94.2 593.4.4 164.1 94.7 164.6 248 1 342.4-163.6 94.4-429.2 94.2-593.4-.4-164.1-94.7-164.6-248-1-342.5Z"
                />
                <path
                    fill="url(#es_database_f)"
                    fill-rule="evenodd"
                    d="M1030.5 426.6c.2-4.4.2-8.7 0-13.1V301.7h-42.3c-25-33.2-61-64.2-108-91.4C680 94.8 356 94.6 156.5 209.8c-47.2 27.2-83.2 58.5-108 91.9h-41v105.7c-4.9 79.3 45.1 159.5 150.1 220.1 200.2 115.5 524.2 115.7 723.7.5 96.5-55.7 146.2-128.3 149.1-201.4Z"
                />
                <path
                    fill="#ced4db"
                    fill-rule="evenodd"
                    d="M156.4 94.1c199.5-115.2 523.5-114.9 723.7.5 200.2 115.5 200.7 302.5 1.2 417.7-199.5 115.2-523.5 114.9-723.7-.5-200.2-115.5-200.7-302.5-1.2-417.7Z"
                />
                <path
                    fill="#09264a"
                    d="M1004.4 393.3C980.2 437 938.1 477 880.2 510.4c-99.1 57.2-229.4 85.8-359.8 85.8-130.9 0-261.9-28.8-361.7-86.4-60.5-34.9-103.9-76.9-127.8-122.7-1.1 1-2.3 1.9-3.4 2.9 24.4 46.2 68.2 88.5 129.1 123.6 97.1 56 226.1 87 363.2 87.1h.7c136.8 0 265.3-30.7 362-86.5 58.1-33.5 100.5-73.7 125.2-117.7l-3.2-3.2Z"
                />
                <path
                    fill="none"
                    fill-rule="evenodd"
                    stroke="#fff"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    stroke-width="14"
                    d="M1030.5 310.9c3.1-78-47-156.6-150.3-216.2C680-20.8 356-21 156.5 94.2 52.2 154.3 2.6 234.1 7.5 313v94.4c-4.9 79.3 45.1 159.5 150.1 220.1 200.2 115.5 524.2 115.7 723.7.5 96.5-55.7 146.2-128.3 149.1-201.4h0c.2-4.4.2-8.8 0-13.1V310.8Z"
                />
                <path
                    fill="none"
                    fill-rule="evenodd"
                    stroke="#09264a"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    stroke-width="3.6"
                    d="M221.7 131.8c163.6-94.4 429.2-94.2 593.4.4 164.1 94.7 164.6 248 1 342.4-163.6 94.4-429.2 94.2-593.4-.4-164.1-94.7-164.6-248-1-342.5Z"
                />
                <path
                    fill="#5cb253"
                    d="m699.2 240.4 31.3-46.5c-13.5-9.4-28.9-17.8-46.3-25.3-27.6-11.8-58.1-20.4-91.6-25.7-15.8-2.5-31.9-4.3-48.1-5.5-11.5-.8-23.1-1.3-34.8-1.5-19.4-.3-38.9 0-58.4.9l64.8 41.3-30 43.1c7.7-.2 15.5 0 23.6.4 35.5 2 67.4 9 95.5 21 2.7 1.1 5.3 2.3 7.8 3.5l86.2-5.7Z"
                />
                <path
                    fill="#5cb253"
                    d="M404 172.4c-11.1 2.6-21.7 5.5-31.9 8.9l41.3 8.9 4.5 23.2c1.5-.5 3.1-1.1 4.6-1.6 21.4-7.1 44.2-12.1 68.5-14.8l12.3-17.6-26.9-17.1c-24.8 1.3-49 4.7-72.4 10.1Z"
                />
                <path
                    fill="#5cb253"
                    d="m403.1 194.6-42.7-9.2c-14.2 5.3-27.5 11.4-39.8 18.3-20.6 11.6-37 24.8-49.2 39.5l49-5.8 29.8 20.4c1-1.3 2.1-2.6 3.3-4 12.9-14.8 30.9-26.9 54.1-36.4l-4.5-22.8ZM641.4 346.1c4.6-4.3 8.4-8.7 11.4-13.2l46.2 31.3 77.6-9.4c-4.4 6.8-9.7 13.5-15.8 20.1-16 17.2-37 32.1-63.1 44.8-26.5 12.9-56.5 22.2-90 28.1l-2 .3-57.5-27.2 15.1-37 1.1-.3c32.9-7.8 58.6-20.4 76.9-37.7Z"
                />
                <path
                    fill="#5cb253"
                    d="M752 211.2c-4.2-3.9-8.7-7.7-13.4-11.4l-31.3 46.4-83.7 5.5c17.7 10.5 29.3 23.2 34.7 38 4.6 12.5 4.1 24.6-1.5 36.1l46.5 31.4 77.5-9.3c4.9-8.7 8.4-17.6 10.8-26.7 4.8-19 3.9-37.9-2.9-56.7-6.8-19-19-36.8-36.7-53.4ZM266 250.2l50-5.9 29.5 20.1c-9 14.4-11.3 29.5-6.8 45.1 1.3 4.4 3 8.7 5.2 12.9l-52.8-6.7-38 25.1c-4.6-11.1-6.8-22.5-6.8-34.1 0-19.3 6.5-38 19.2-56 .1-.2.2-.4.4-.5Z"
                />
                <path
                    fill="#5cb253"
                    d="M381.7 360.2c-14.8-9.4-26-19.7-33.5-30.9l-52.8-6.7-38.7 25.6c2.6 5.1 5.6 10.1 9.1 15 13 18.1 31.6 34.1 55.9 48.1 14.5 8.3 30.4 15.5 47.7 21.6l-2.8-38.2 52.5-16.8c-13.7-4.6-26.1-10.5-37.3-17.6Z"
                />
                <path
                    fill="#5cb253"
                    d="M430.4 381.3c11.3 3.1 23.4 5.5 36.2 7.2 28.8 3.7 56.8 3.1 84.2-1.9l-14.9 36.8 57 26.9c-28.5 4.2-57.6 5.9-87.3 5.4-34.7-.6-68-4.7-99.9-12.3-8.6-2-16.8-4.3-24.8-6.8l-2.8-38.5 52.5-16.8Z"
                />
            </svg>
        );
    }
}
